module.exports = __webpack_public_path__ + "img/Kubernetes.25f075c.svg";